import { motion } from "framer-motion";
import { Check } from "@phosphor-icons/react";

// Elegant "quest" step tracker in the Old Money palette (oxblood/gold/cream).
// steps: [{ k, t }]   step: index of the current/active step (0-based). done when i < step.
export function QuestProgress({ steps, step, className = "", testid = "quest-progress" }) {
  const pct = steps.length > 1 ? (Math.min(step, steps.length - 1) / (steps.length - 1)) * 100 : 0;
  return (
    <div data-testid={testid} className={`relative flex items-start justify-between px-1.5 ${className}`}>
      <div className="absolute top-3 left-6 right-6 h-0.5 bg-[#1A1715]/12 rounded-full overflow-hidden">
        <motion.div className="h-full rounded-full" style={{ background: "linear-gradient(90deg,#B08D57,#7E1119)" }}
          initial={false} animate={{ width: `${pct}%` }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }} />
      </div>
      {steps.map((s, i) => {
        const done = i < step, active = i === step;
        return (
          <div key={s.k} data-testid={`${testid}-node-${s.k}`} className="relative z-[1] flex flex-col items-center gap-1.5 flex-1">
            <motion.span
              animate={{ scale: active ? 1.08 : 1 }} transition={{ type: "spring", stiffness: 360, damping: 20 }}
              className="grid place-items-center w-6 h-6 rounded-full text-[11px] font-bold transition-colors duration-300"
              style={{
                background: done ? "#4A0000" : active ? "#B08D57" : "#fff",
                color: done || active ? "#fff" : "#8a857c",
                border: done ? "1.5px solid #4A0000" : active ? "1.5px solid #B08D57" : "1.5px solid rgba(26,23,21,.18)",
                boxShadow: active ? "0 0 0 4px rgba(176,141,87,.18)" : "none",
              }}>
              {done ? <Check size={13} weight="bold" /> : i + 1}
            </motion.span>
            <span className={`text-[10px] tracking-[0.06em] uppercase transition-colors ${active ? "text-[#4A0000] font-bold" : done ? "text-[#7a756c] font-semibold" : "text-[#a8a39a] font-medium"}`}>{s.t}</span>
          </div>
        );
      })}
    </div>
  );
}
